import { render } from "./Parkings.vue?vue&type=template&id=5c454516"
import script from "./Parkings.vue?vue&type=script&lang=js"
export * from "./Parkings.vue?vue&type=script&lang=js"
script.render = render

export default script